import store from "@/store";
import { PartnerSettingsState } from "@/store/modules/partnerModule";
import { EAnalyticsIntegrationType } from "@/enums/EAnalyticsIntegrationType";

// Determines which analytics pipeline is active for the current partner.
//
// Direct       -> existing behaviour (Firebase Analytics, Meta Pixel, GTM) - unchanged
// RudderStack  -> events are sent only to RudderStack, direct integrations are skipped
//
// Configured per-partner via the partnerSettings.analyticsIntegrationType field,
// fetched from the customerSettings API (same mechanism as the rest of PartnerSettings).
export function isRudderStack(): boolean {
    const partnerSettings = ((store as any).state["partner"] as PartnerSettingsState).partnerSettings;
    return partnerSettings?.analyticsIntegrationType === EAnalyticsIntegrationType.RudderStack;
}
